import React, { PureComponent } from "react";
import { Parallax } from "react-skrollr";
import _ from "lodash";
import { Feather } from "../components";

export default class FeatherLoop extends PureComponent {
  render() {
    const { index } = this.props;
    const key = index + 1;
    const feathers = [key * 2 - 1, key * 2];
    return (
      <div className="feather-block">
        {_.includes(feathers, 1) && (
          <div className="feather feather-1">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-20px) translateY(-200px) translateZ(0px) scale(1) rotate(30deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(10deg);"
              }}
            >
              <Feather type={1} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 2) && (
          <div className="feather feather-2">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(10px) translateY(-100px) translateZ(0px) scale(1) rotate(90deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(0deg);"
              }}
            >
              <Feather type={2} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 3) && (
          <div className="feather feather-3">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-5px) translateY(-150px) translateZ(0px) scale(1) rotate(-40deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(0deg);"
              }}
            >
              <Feather type={3} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 4) && (
          <div className="feather feather-4">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-50px) translateY(-150px) translateZ(0px) scale(1) rotate(-40deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(20deg);"
              }}
            >
              <Feather type={9} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 5) && (
          <div className="feather feather-5">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(10px) translateY(-100px) translateZ(0px) scale(1) rotate(-10deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(20deg);"
              }}
            >
              <Feather type={4} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 6) && (
          <div className="feather feather-6">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(-10px) translateY(-50px) translateZ(0px) scale(1) rotate(0deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(-45deg);"
              }}
            >
              <Feather type={2} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 7) && (
          <div className="feather feather-7">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(10px) translateY(-50px) translateZ(0px) scale(1) rotate(-25deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(25deg);"
              }}
            >
              <Feather type={9} />
            </Parallax>
          </div>
        )}
        {_.includes(feathers, 8) && (
          <div className="feather feather-8">
            <Parallax
              data={{
                "data-bottom-top":
                  "transform: translateX(0px) translateY(-50px) translateZ(0px) scale(1) rotate(0deg);",
                "data-top-bottom":
                  "transform: translateX(0px) translateY(0px) translateZ(0px) scale(1) rotate(45deg);"
              }}
            >
              <Feather type={7} />
            </Parallax>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FeatherLoop.js